import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    asdf({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'url/', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    estadisticas_panel({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'estadisticas/panel', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    estadisticas_getInvoices({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'estadisticas/get-invoices', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};